module.exports = __webpack_public_path__ + "a8a10a3e/img/file-icon.c085e21e.svg";